@if (followupsLoading) {
	<div class="followups-loader">
		<app-spin />
		<span>{{ "loading" | langVal }}</span>
	</div>
} @else {
	<div class="form-group colstat-big mx-auto py-3">
		<label>{{ "external_invoice_id" | langVal }}</label>
		<app-gen-input
			[actualObj]="this"
			isNumber
			title_ph_lang="external_invoice_id"
			fieldName="invoice_id"
			(keyupEvent)="validateEntireForm()"
			class="colstat-big"
		/>
	</div>
	<div class="table-responsive my-4 mx-3">
		<table
			style="width: 100%"
			class="invoice-payment-details table table-hover table-striped"
		>
			<thead>
				<tr>
					<th>
						<input
							type="checkbox"
							[checked]="followupsAllChecked"
							(change)="checkAll($event.target.checked)"
						/>
					</th>
					@if (resource == "payor") {
						<th>{{ "patient" | langVal }}</th>
					}
					<th>{{ "type" | langVal }}</th>
					<th>{{ "date" | langVal }}</th>
					<th>{{ "price" | langVal }}</th>
					@if (is_add_assoc) {
						<th>{{ "therapist" | langVal }}</th>
					}
				</tr>
			</thead>
			<tbody>
				@for (followup of followups; track followup) {
					<tr>
						<td>
							<input
								type="checkbox"
								[checked]="followup.checked"
								(change)="followupCheck(followup, $event.target.checked)"
							/>
						</td>
						@if (resource == "payor") {
							<td>{{ followup.patient_name }}</td>
						}
						<td>{{ followup.meetingtype_name }}</td>
						<td>{{ followup.date | dateFormat }}</td>
						<td class="display-number">
							{{ followup.price | finNumber }}
						</td>
						@if (is_add_assoc) {
							<td>{{ followup?.assoc }}</td>
						}
					</tr>
				}

				@if (followups.length) {
					<tr>
						<td></td>
						<td [attr.colspan]="resource == 'payor' ? 3 : 2">
							{{ "total" | langVal }}
						</td>
						<td class="display-number">
							{{ fpSum | finNumber }}
						</td>
					</tr>
				}
			</tbody>
		</table>
	</div>
	<div class="row">
		<div class="col-12 modal-btns text-end">
			<app-cancel-btn (click)="onClose.emit()" />

			<app-btn-ext
				[isSpin]="isSaving"
				[disabled]="!isFormSubmittable"
				(clickEv)="save()"
				text="confirm"
			/>
		</div>
	</div>
}
